module.exports = __webpack_public_path__ + "static/img/image-placeholder.501f7f9c.svg";